import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialog) = $event)),
        title: 'Ajouter un mail',
        minWidth: '800px'
      }, {
        actions: _withCtx(() => [
          (_ctx.windowStep !== 'default')
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pr-2"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                            key: 0,
                            rounded: "",
                            block: "",
                            disabled: !_ctx.valid,
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.testAndCreation(_ctx.type))),
                            size: "x-large"
                          }, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createTextVNode("Ajouter")
                            ])),
                            _: 1
                          }, 8, ["disabled"]))
                        : (_openBlock(), _createBlock(_component_v_btn_primary, {
                            key: 1,
                            rounded: "",
                            block: "",
                            icon: "",
                            size: "x-large"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_progress_circular, {
                                size: 40,
                                width: 7,
                                color: "white",
                                indeterminate: "",
                                style: {"margin":"24px"}
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.windowStep,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.windowStep) = $event)),
            touchless: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 'default' }, {
                default: _withCtx(() => [
                  (_ctx.type === 'sendingMail')
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        class: "d-flex align-center justify-center",
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createElementVNode("p", null, " Les adresses Gmail ne sont pas prises en charge, mais arrivent bientôt sur bobbee ", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_container, {
                    fluid: "",
                    "grid-list-md": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { subheader: "" }, {
                        default: _withCtx(() => [
                          (_ctx.type == 'accountingMail')
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                class: "mb-2",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => {
                                    _ctx.connectToAccountingMail();
                                    _ctx.type = '';
                                })
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                      _createTextVNode("Gmail")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_ctx.type == 'documentFromMail')
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 1,
                                  class: "mb-2",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => {
                                    _ctx.connectToDocumentFromMail();
                                    _ctx.type = '';
                                })
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_next)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                                        _createTextVNode("Gmail")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, {
                            class: "oss-list-item mb-2",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.windowStep = 'notGmailVue'))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_btn_next)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode("Autre messagerie")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 'notGmailVue' }, {
                default: _withCtx(() => [
                  (_ctx.type === 'sendingMail')
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        class: "d-flex align-center justify-center",
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createElementVNode("p", null, " Les adresses Gmail ne sont pas prises en charge, mais arrivent bientôt sur bobbee ", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_card, {
                    class: "default_card large mx-0 pa-2",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        ref: "form",
                        modelValue: _ctx.valid,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.valid) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            align: "center",
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                class: "d-flex pr-1",
                                cols: "12",
                                sm: "7"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.email,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                                    type: "text",
                                    label: "Email",
                                    required: "",
                                    rules: [_ctx.rules.isEmail, _ctx.rules.notAlreadyUsedMail],
                                    outlined: "",
                                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.adaptHostToEmail())),
                                    density: "compact"
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                class: "d-flex pr-1",
                                cols: "12",
                                sm: "5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_combobox_filled, {
                                    modelValue: _ctx.host,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.host) = $event)),
                                    items: 
                                            _ctx.type === 'sendingMail' ? _ctx.listHostsSmtp : _ctx.listHostsImap
                                        ,
                                    label: 
                                            _ctx.type === 'sendingMail' ? 'Serveur SMTP' : 'Serveur IMAP'
                                        ,
                                    required: "",
                                    rules: [_ctx.rules.notEmpty],
                                    disabled: _ctx.hostDisabled,
                                    outlined: "",
                                    dense: ""
                                  }, null, 8, ["modelValue", "items", "label", "rules", "disabled"]),
                                  _createVNode(_component_v_btn_icon, {
                                    icon: "$oss-edit",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hostDisabled = !_ctx.hostDisabled))
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, {
                            align: "center",
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                class: "d-flex pr-1",
                                cols: "12",
                                sm: "7"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.password,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.password) = $event)),
                                    "append-inner-icon": "$oss-eye",
                                    type: _ctx.show ? 'text' : 'password',
                                    label: "Mot de Passe",
                                    required: "",
                                    rules: [_ctx.rules.notEmpty],
                                    outlined: "",
                                    density: "compact",
                                    "onClick:appendInner": _cache[8] || (_cache[8] = ($event: any) => (_ctx.show = !_ctx.show))
                                  }, null, 8, ["modelValue", "type", "rules"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                class: "d-flex pr-1",
                                cols: "12",
                                sm: "5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.port,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.port) = $event)),
                                    type: "text",
                                    label: "Port",
                                    required: "",
                                    rules: [_ctx.rules.notEmpty],
                                    disabled: _ctx.portDisabled,
                                    outlined: "",
                                    density: "compact"
                                  }, null, 8, ["modelValue", "rules", "disabled"]),
                                  _createVNode(_component_v_btn_icon, {
                                    icon: "$oss-edit",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.portDisabled = !_ctx.portDisabled))
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_alert, {
                        type: "error",
                        "model-value": _ctx.errorCredentials
                      }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("Adresse mail, mot de passe ou serveur IMAP incorrect ")
                        ])),
                        _: 1
                      }, 8, ["model-value"]),
                      _createVNode(_component_v_alert, {
                        type: "error",
                        "model-value": _ctx.errorCredentials2
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode("Adresse mail incorrecte ")
                        ])),
                        _: 1
                      }, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}